import React, { useState, useContext, useEffect } from 'react';
import {
	IconButton,
	Container,
	Button,
	Paper,
	Typography,
	Stack,
	TableContainer,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Table
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment/moment';
import Swal from 'sweetalert2';

import { getToken } from '../../../../api/Account';
import { isAccess, simpleMessage } from '../../../../helpers/Helpers';
import { DataContext } from '../../../../context/DataContext';
import { isEmpty } from 'lodash';
import NoData from '../../../../components/NoData';
import SmallModal from '../../../../components/modals/SmallModal';

import AddSubcidio from '../subcidios/AddSubcidio';
import { getSubcidiosAsync, deleteSubcidioAsync } from '../../../../api/Nomina';

const Subsidios = ({ id }) => {
	const [historySubcidio, setHistorySubcidio] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [localReload, setLocalReload] = useState(false);

	const token = getToken();
	const { setIsLoading, setIsUnautorized, access } = useContext(DataContext);

	const getSubcidio = async () => {
		setIsLoading(true);
		const result = await getSubcidiosAsync(token, id);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		setHistorySubcidio(result.data.result);
		setIsLoading(false);
	};

	useEffect(() => {
		getSubcidio();
	}, [localReload]);

	const deleteSubcidio = async (id) => {
		Swal.fire({
			title: '¿Confirmar Eliminar?',
			text: 'No podras revertir esto...!',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#2979ff',
			cancelButtonColor: '#f50057',
			confirmButtonText: 'Eliminar!',
			cancelButtonText: 'Cancelar',
			customClass: {
				popup: 'border'
			}
		}).then((result) => {
			if (result.isConfirmed) {
				(async () => {
					setIsLoading(true);
					const result = await deleteSubcidioAsync(token, id);
					if (!result.statusResponse) {
						setIsLoading(false);
						if (result.error === 'Unauthorized') {
							setIsUnautorized(true);
							return;
						}
						simpleMessage(result.error, 'error');
						return;
					}
					setIsLoading(false);
					setLocalReload(!localReload);
					Swal.fire('Eliminado!', 'Subcidio Eliminado.', 'success');
				})();
			}
		});
	};

	return (
		<div>
			<Container maxWidth="xl">
				<Paper
					style={{
						padding: 20
					}}
				>
					<Stack
						marginTop={2}
						direction={{ xs: 'column', sm: 'row' }}
						alignItems="center"
						justifyContent={'space-between'}
					>
						<Typography color={'#00a152'} variant="h4" fontWeight={'bold'}>
							Historial de Subcidios
						</Typography>

						<Button
							onClick={() => {
								setShowModal(!showModal);
							}}
							style={{
								color: '#2979ff',
								borderColor: '#2979ff'
							}}
							variant="outlined"
						>
							<FontAwesomeIcon
								style={{ marginRight: 10, fontSize: 20 }}
								icon={faCirclePlus}
							/>
							Agregar
						</Button>
					</Stack>

					<hr />

					{isEmpty(historySubcidio) ? (
						<NoData />
					) : (
						<Stack spacing={2}>
							<TableContainer>
								<Table aria-label="simple table" size="small">
									<TableHead>
										<TableRow>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												#
											</TableCell>
											<TableCell
												align="left"
												className="text-primary fw-bold"
											>
												Motivo
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Desde
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Hasta
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Días
											</TableCell>

											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Riesgo Laboral
											</TableCell>

											{isAccess(access, 'NOMINA DELETE') ? (
												<TableCell
													align="center"
													className="text-primary fw-bold"
												>
													Acciones
												</TableCell>
											) : (
												<></>
											)}
										</TableRow>
									</TableHead>

									<TableBody>
										{historySubcidio.map((row) => {
											const {
												motivo,
												id,
												desde,
												isRiesgoLaboral,
												hasta,
												dias,
												diasRestantes
											} = row;
											return (
												<TableRow key={id}>
													<TableCell
														align="center"
														component="th"
														scope="row"
													>
														{id}
													</TableCell>
													<TableCell align="left">{motivo}</TableCell>
													<TableCell align="center">
														{moment(desde).format('L')}
													</TableCell>
													<TableCell align="center">
														{moment(hasta).format('L')}
													</TableCell>
													<TableCell align="center">{dias}</TableCell>

													<TableCell align="center">
														{isRiesgoLaboral ? 'SI' : 'NO'}
													</TableCell>

													<TableCell align="center">
														{isAccess(access, 'NOMINA DELETE') ? (
															<IconButton
																style={{
																	color: '#f50057',
																	width: 40,
																	height: 40
																}}
																onClick={() =>
																	deleteSubcidio(row.id)
																}
															>
																<FontAwesomeIcon
																	icon={faTrashAlt}
																/>
															</IconButton>
														) : (
															<></>
														)}
													</TableCell>
												</TableRow>
											);
										})}
									</TableBody>
								</Table>
							</TableContainer>
						</Stack>
					)}
				</Paper>
			</Container>

			<SmallModal titulo={'Agregar Subcidio'} isVisible={showModal} setVisible={setShowModal}>
				<AddSubcidio
					id={id}
					setShowModal={setShowModal}
					reload={localReload}
					setReload={setLocalReload}
				/>
			</SmallModal>
		</div>
	);
};

export default Subsidios;
